import React from 'react';
import ProfileImg from '../../../images/user.jpg'
import LocalStore from '../../../utils/localStorageUtil'

const TopNav = ({ logoutHandler, changePasswordHandler }) => {
    return (
        <div className="profile-setting-popup animate-vibrate">
            <div className="my-profile dark-background">
                <img src={ProfileImg} alt="img" />
                <p>{LocalStore.getFromLocalStorage('loginUser')}</p>
                {/* <small>
                    {"Kognetics"}
                    <br />
                    {"https://www.kognetics.com"}
                </small> */}
            </div>
            <ul>
                <li onClick={e => changePasswordHandler('open')}>
                    <div className="sign-out-btn"><i className="fa fa-key" />&nbsp;&nbsp;Change Password</div>
                </li>
                <li onClick={e => logoutHandler()}>
                    <div className="sign-out-btn"><i className="fa fa-sign-out" />&nbsp;&nbsp;Sign Out</div>
                </li>
            </ul>
        </div>
    )
}

export default TopNav;

